import './EntityField.scss';
import Entity from './Entity';
import EntitySelectModal from './EntitySelectModal';
import React from 'react';

class EntityField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selecting: false
    };

    this.handleRemoveEntity = this.handleRemoveEntity.bind(this);
    this.handleToggleSelector = this.handleToggleSelector.bind(this);
    this.handleSelection = this.handleSelection.bind(this);
  }

  handleRemoveEntity() {
    if (!this.props.disabled) {
      this.props.onChange(this.props.name, null);
    }
  }

  handleToggleSelector() {
    if (!this.props.disabled) {
      this.setState({
        selecting: !this.state.selecting
      });
    }
  }

  handleSelection(selection) {
    if (!this.props.disabled) {
      this.props.onChange(this.props.name, selection);
      this.setState({
        selecting: false,
        editing: false
      });
    }
  }

  render() {
    const entity = this.props.value;

    return (
      <div className={`${this.props.disabled ? 'disabled ' : ''}contentful-entity-field`}>
        {entity &&
          <div>
            <Entity
              entity={entity}
              disabled={this.props.disabled}
              allowEdit={this.props.allowEdit}
              onRemove={this.handleRemoveEntity}
            />

            <p className="text-left">
              <a
                className={`${(this.state.selecting ? 'active ' : '') + (this.props.disabled ? 'disabled ' : '')}btn btn-default`}
                onClick={this.handleToggleSelector}
              >
                <i className="fa fa-pencil" aria-hidden="true"></i> Velg annen
              </a>
            </p>
          </div>
        }
        {!entity &&
          <div>
            <div className="contentful-entity-field-slot well h4">
              Entitet mangler
            </div>
            <p className="text-left">
              <a
                className={`${(this.state.selecting ? 'active ' : '') + (this.props.disabled ? 'disabled ' : '')}btn btn-default`}
                onClick={this.handleToggleSelector}
              >
                <i className="fa fa-pencil" aria-hidden="true"></i> Velg
              </a>
            </p>
          </div>
        }

        <EntitySelectModal
          show={this.state.selecting}
          onSelect={this.handleSelection}
          onHide={this.handleToggleSelector}
          contentType={this.props.contentType}
          searcher={this.props.searcher}
          createUrl={this.props.createUrl}
          searchParams={this.props.searchParams}
          searchOnOpen={this.props.searchOnOpen}
        />
      </div>
    );
  }
}

EntityField.defaultProps = {
  value: null,
  name: 'entity',
  disabled: false,
  onChange: () => {}
};

export default EntityField;
